module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.value)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.value && _vm.withId) ? _c('span', [_vm._v("#" + _vm._s(_vm.value.id))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.titleText) + "\n    ")]), _vm._v(" "), _vm._t("sub-title", function() {
    return [(_vm.subTitleText) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.subTitleText) + "\n      ")]) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab6736c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/GenericListItem.vue
// module id = 1662
// module chunks = 2